import { connect } from 'react-redux'
import * as actions from '../store/actions'
import Collapse from '@material-ui/core/Collapse'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import React, { Component } from 'react'
import MenuStyle from '../styles/MenuStyle'

class Menu extends Component {
  state = {
    openIds: [],
  }

  handleClick = id => {
    const newOpenIds = [...this.state.openIds]
    newOpenIds.includes(id)
      ? newOpenIds.splice(newOpenIds.indexOf(id), 1)
      : newOpenIds.push(id)
    this.setState({ openIds: newOpenIds })
  }

  selectPage = page => {
    const { fileId, sections, downloadSections, onSaveSections } = this.props
    onSaveSections(fileId, sections)
    downloadSections(fileId, page)
  }

  selectValidity = () => {
    const { fileId, sections, onFetchSections, onSaveSections } = this.props
    onSaveSections(fileId, sections)
    onFetchSections([{ TypSekcji: 'Walidacja' }])
  }

  isExpanded = id => this.state.openIds.includes(id)

  componentDidMount() {
    this.setState({
      openIds: this.props.menu.map(m => m.Dzieci.length && m.Id),
    })
  }

  getErrorsCount(el) {
    const { validityErrors } = this.props
    if (validityErrors && validityErrors.length) {
      return validityErrors.filter(
        x =>
          el.Dzieci.find(y => y.Sekcje.includes(x.TypSekcji)) ||
          el.Sekcje.includes(x.TypSekcji),
      ).length
    }
    return 0
  }

  render() {
    const { menu, sections } = this.props
    return (
      <MenuStyle>
        <List component="nav">
          {menu.map(el =>
            el.Dzieci.length ? (
              <div key={el.Id}>
                <ListItem
                  data-cy="menu-item"
                  className="primary-level"
                  button
                  onClick={() => this.handleClick(el.Id)}
                >
                  <span className="primary-level-text">
                    {el.NazwaWyswietlana}
                  </span>
                  {this.isExpanded(el.Id) ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse
                  in={this.isExpanded(el.Id)}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {el.Dzieci.map(child => (
                      <ListItem
                        data-cy="menu-item"
                        key={child.Id}
                        className={
                          sections[0].TypSekcji === child.Sekcje[0]
                            ? 'active item'
                            : 'item'
                        }
                        button
                        onClick={() => this.selectPage(child.Id)}
                      >
                        <span
                          className={
                            sections[0].TypSekcji === child.Sekcje[0]
                              ? 'sublevel sublevel-active'
                              : 'sublevel'
                          }
                        >
                          {child.NazwaWyswietlana}
                        </span>
                        {this.getErrorsCount(child) > 0 && (
                          <div className="errorCount">
                            <p>{this.getErrorsCount(child)}</p>
                          </div>
                        )}
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              </div>
            ) : (
              <ListItem
                data-cy="menu-item"
                button
                key={el.Id}
                className={
                  sections[0].TypSekcji === el.Sekcje[0]
                    ? 'active item'
                    : 'item'
                }
                onClick={() => this.selectPage(el.Id)}
              >
                <span className="primary-level-text">
                  {el.NazwaWyswietlana}
                </span>
                {this.getErrorsCount(el) > 0 && (
                  <div className="errorCount">
                    <p>{this.getErrorsCount(el)}</p>
                  </div>
                )}
              </ListItem>
            ),
          )}
          <ListItem
            data-cy="menu-item"
            button
            className={
              sections[0].TypSekcji === 'Walidacja' ? 'active item' : 'item'
            }
            onClick={this.selectValidity}
          >
            <span className="primary-level-text">
              Weryfikacja i zapis sprawozdania
            </span>
          </ListItem>
        </List>
      </MenuStyle>
    )
  }
}

const mapStateToProps = state => {
  return {
    sections: state.sprawozdanie.sections,
    fileId: state.sprawozdanie.header.Id,
    validityErrors: state.sprawozdanie.validityErrors,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    downloadSections: (fileId, page) =>
      dispatch(actions.downloadSections(fileId, page)),
    onSaveSections: (fileId, sections) =>
      dispatch(actions.saveSections(fileId, sections)),
    onFetchSections: sections => dispatch(actions.fetchSections(sections)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Menu)
